import { render } from "./HomeView.vue?vue&type=template&id=55489aba"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/tikam/Documents/2023/Ferat/FERAT FINAL/routerlinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__